import { createI18n } from 'vue-i18n'
import axios from 'axios'
import config from '../config'

// Lista delle lingue supportate
export const supportedLocales = ['en-GB', 'it-IT']
// if(config.currentEnv === 'dev') {
//   supportedLocales.push('it-IT') // Aggiungi italiano solo in ambiente di sviluppo
// }

// Funzione per ottenere il locale preferito
export function getUserLocale() {
  if(window.location.href.includes('analytics-webview') || window.location.href.includes('analytics-global-webview')) {
    console.log("Forcing en-GB for webview");
    return 'en-GB';
  }
  const saved = localStorage.getItem('smeg-dashboard-locale')
  const browser = navigator.language || navigator.userLanguage
  return supportedLocales.includes(saved) ? saved
       : supportedLocales.includes(browser) ? browser
       : 'en-GB'
}

// Funzione asincrona per caricare i messaggi da remoto
export async function loadMessages(locale, tenant) {
  console.log("Loading messages for locale and tenant:", locale, tenant);

  let translations = tenant ? await loadStatuses(locale, tenant) : {};

  if(config.currentEnv === 'dev') {
    const lang = locale.startsWith('it') ? 'it' : 'en';
    const url = `/labels/${lang}.json`;
    const response = await axios.get(url);
    return { ...response.data, ...translations };
    // return response.data;
  }

  try {
    // const url = config.environment[config.currentEnv]["smegcons"].api.labels + lang;
    let parameters = {
      platform: 'dashboard',
      lastModified: 0,
      lang: locale
    };
    const url = config.labels(tenant) + `?${new URLSearchParams(parameters).toString()}`;
    const response = await axios.get(url);
    
    return { ...response.data.keys, ...translations };
    // return response.data.keys;
  } catch (error) {
    console.error(`Error loading messages for locale ${locale} from Bloomreach:`, error);
    const lang = locale.startsWith('it') ? 'it' : 'en'; // semplifica per ora
    const url = `/labels/${lang}.json`;
    const response = await axios.get(url);
    return { ...response.data, ...translations };
    // return response.data;
  }
}

async function loadStatuses(locale, tenant) {
  const lang = locale.startsWith('it') ? 'it' : 'en';
  const url = `/labels/statuses/${tenant}_${lang}.json`;
  const response = await axios.get(url);
  return response.data;
}


const genericNumberFormats = {
  verbose_percentage: {
    style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
  }
}

const numberFormats = {
  "en-GB": genericNumberFormats,
}

// Creazione dell'istanza i18n con caricamento asincrono
export async function setupI18n() {
  const locale = getUserLocale()
  const messages = {
    // [locale]: await loadMessages(locale)
  }
  if(config.env()!=null) {
    messages[locale] = await loadMessages(locale, "smegcons");
  }

  const i18n = createI18n({
    // legacy: false,
    locale,
    fallbackLocale: 'en-GB',
    messages,
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    numberFormats
  })

  return i18n
}
